import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal-page";

export const Route = createFileRoute("/refund-policy")({
  head: () => ({
    meta: [
      { title: "Cancellation & Refund Policy - DeckScore" },
      { name: "description", content: "Cancellation and refund terms for DeckScore paid services." },
      { name: "robots", content: "noindex" },
      { property: "og:title", content: "Cancellation & Refund Policy - DeckScore" },
      { property: "og:description", content: "Cancellation and refund terms for DeckScore paid services." },
    ],
  }),
  component: RefundPolicy,
});

function RefundPolicy() {
  return (
    <LegalPage title="Cancellation & Refund Policy">
      <p><strong>Cancellation &amp; Refund Policy</strong></p>
      <p><strong>Effective Date: 11 July 2026</strong></p>
      <p>This policy applies to DeckScore's paid services, operated by Adviselo Collab Studios Private Limited.</p>

      <h2>1. Free Services</h2>
      <p>Our AI pitch-deck analysis and investor-readiness score are provided free of charge, and no payment or refund is involved.</p>

      <h2>2. Paid Investor-Introduction Service</h2>
      <p>Our paid service involves preparing your one-pager and sending it to investors as a warm introduction - a done-for-you service that begins as soon as you pay.</p>

      <h2>3. Cancellations and Refunds</h2>
      <ul>
        <li>You may request a cancellation and full refund at any time BEFORE we have begun outreach on your behalf (i.e., before your one-pager has been sent to any investor).</li>
        <li>Once outreach has begun and your one-pager has been sent to one or more investors, the service is considered delivered and payments are non-refundable, as the work cannot be undone.</li>
        <li>If we are unable to deliver the paid service due to a technical failure on our end, you are entitled to a full refund.</li>
      </ul>

      <h2>4. How to Request a Refund</h2>
      <p>
        Email <a href="mailto:info@ikomatch.com">info@ikomatch.com</a> with your registered name, email, and payment reference. Eligible refunds are processed to your original payment method within 5-7 business days.
      </p>

      <h2>5. Contact</h2>
      <p>For any billing or refund questions, contact <a href="mailto:info@ikomatch.com">info@ikomatch.com</a>.</p>
    </LegalPage>
  );
}
